<template>
  <div class="house-input-component">
    <vue-suggest
      v-model="model"
      ref="suggestComponent"
      :destyled="true"
      pattern="\w+"
      :list="getList"
      :max-suggestions="30"
      :min-length="1"
      :debounce="300"
      :filter-by-query="false"
      :controls="{
        selectionUp: [38, 33],
        selectionDown: [40, 34],
        select: [13, 36],
        showList: [40],
        hideList: [27, 35],
      }"
      :mode="mode"
      :nullable-select="true"
      placeholder=""
      value-attribute="value"
      display-attribute="value"
      :disabled="!allowManual && !streetId"
      @select="onSuggestSelect"
      @input="onInput"
      @blur="onBlur"
    >
      <!-- <input type="text"> -->

      <!--      <div class="query">
        <input v-bind="$attrs" :placeholder="placeholder" type="text" class="input-text_input" :disabled="!streetId">
      </div>-->

      <!-- <test-input placeholder="Search information..." /> -->

      <template v-slot:misc-item-above="{ suggestions }">
        <div
          v-if="false && suggestions.length === 0 && !loading"
          class="misc-item"
        >
          <span>Ничего не найдено..."</span>
        </div>
      </template>

      <template v-slot:suggestion-item="scope">
        <div class="text">
          <span v-html="boldenSuggestion(scope)" />
        </div>
      </template>

      <template v-slot:misc-item-below="{ query }">
        <div v-if="false && loading && query" class="misc-item">
          <span>Поиск...</span>
        </div>
      </template>
    </vue-suggest>
  </div>
</template>

<script>
  import VueSuggest from 'vue-simple-suggest'

  export default {
    name: 'HouseInput',
    components: {
      VueSuggest,
    },
    props: {
      streetId: {
        type: String,
        default: '',
      },
      disabled: {
        type: Boolean,
        default: false,
      },
      allowManual: {
        type: Boolean,
        default: false,
      },
      placeholder: {
        type: String,
        default: '',
      },
      initVal: {
        type: String,
        default: '',
      },
    },
    data () {
      return {
        model: null,
        selected: null,
        mode: 'input',
        loading: false,
        log: [],
      }
    },
    computed: {
      val () {
        return this.model
      },
    },
    watch: {
      val (newValue) {
      /* if (this.selected && this.selected.value !== newValue) {
          console.log({
            clear: true,
            newValue: newValue,
            obj: this.selected,
          })
          this.selected = null
          this.onSuggestSelect(null)
        } */
      },

      streetId (newValue, oldValue) {
        if (oldValue && newValue !== oldValue) {
          this.selected = null
          this.onSuggestSelect(null)
          this.model = null
        }
      },
    },
    created () {
      if (this.initVal) {
        this.model = this.initVal
      }
    },
    methods: {
      boldenSuggestion (scope) {
        if (!scope) {
          return scope
        }
        const { suggestion, query } = scope
        const result = this.$refs.suggestComponent.displayProperty(suggestion)
        if (!query) {
          return result
        }
        const texts = query.split(/[\s-_/\\|.]/gm).filter((t) => !!t) || ['']
        return suggestion.value.replace(
          new RegExp('(.*?)(' + texts.join('|') + ')(.*?)', 'gi'),
          '$1<b>$2</b>$3',
        )
      },

      getList (inputValue) {
        if (!this.streetId) return Promise.resolve([])
        this.loading = true
        const payload = {
          query: inputValue,
          streetId: this.streetId,
        }
        return this.$store
          .dispatch('suggests/getSuggestHouse', payload)
          .finally(() => {
            this.loading = false
          })
      },
      onSuggestSelect (suggest) {
        this.$emit('selected', suggest)
        this.selected = suggest
      },
      onInput () {
        this.$emit('input', this.model)
      },
      onBlur () {
        this.$emit('blur')
      },
      setModel (text) {
        this.model = text || null
      },
    },
  }
</script>

<style lang="less">
.house-input-component {
  position: relative;

  .input-text_input,
  .default-input {
    height: 80px;
    background-color: @color-secondary !important;
    border-radius: 15px;
    font-size: 25px;
    line-height: 18px;
    outline: none;
  }

  b {
    font-weight: bold;
  }

  .vue-simple-suggest {
    &.focus .input-wrapper input {
      border: 2px solid #ff9500;
    }

    .suggestions {
      position: absolute;
      left: 0;
      right: 0;
      top: 100%;
      //top: calc(100% + 5px);
      //border: 1px solid #e1e1e1;
      background-color: #fff;
      opacity: 1;
      z-index: 1000;
      max-height: 220px;
      overflow-y: auto;
      box-shadow: 0px 4px 8px 0px rgba(0, 0, 0, 0.3);
      /*,
      0px 8px 10px 1px rgba(0, 0, 0, 0.14),
      0px 3px 14px 2px rgba(0, 0, 0, 0.12);*/
      border-radius: 15px;
      font-size: 16px;
      list-style: none;
      margin: 0;
      padding: 0;
    }

    .suggestions .suggest-item {
      cursor: pointer;
      user-select: none;
      font-size: 16px;
      padding-top: 10px;
      padding-bottom: 10px;
      border-top: 1px solid #f2f2f2;

      .misc-item {
        span {
          margin-bottom: 0;
        }

        &.items-found {
          color: #fe7e00;
          //font-weight: 500;
        }
      }

      &:nth-child(2n) {
        //background: #939393;
      }

      &:not(:last-child) {
        //border-bottom: 1px solid #f2f2f2;
      }

      .area {
        font-weight: bold;
        font-size: 14px;
        margin-bottom: 4px;
      }
    }

    .suggestions .suggest-item,
    .suggestions .misc-item {
      padding: 10px 10px;
    }

    .suggestions .suggest-item.hover {
      background-color: #f2f2f2 !important;
      // color: #fff !important;
    }

    .suggestions .suggest-item.selected {
      //background-color: #2832D5;
      //background-color: #939393;
      //color: #fff;
    }
  }
}
</style>
